import React, { useEffect, useMemo } from 'react'
import Loader from '../../../../../../../../../../shared/Loader/Loader';
import isNull from '../../../../../../../../../../../utils/NullChecking';
import { enumUtil } from '../../../../../../../../../../../utils/Enum';
import { ServerRequestProtected } from '../../../../../../../../../../../utils/ServerDataRequest';

const Vitals = ({ widgetUtilities, ...props }) => {
    const {
        searchParam,
        setSearchParam,
        
        vitalData,setVitalData,
        vitalsPastData, setVitalsPastData,
        pastVitalsLoaded, setPastVitalsLoaded,
        LoadDD,

        initialDataChiefComplaint,
        initialDataVital,
        // initialDataCognitiveStatus,
        // initialDataFunctionalStatus,
        initialDataEncounterID,

        patientID,
        API_URL,
        // RecentICDs,
        // IsEditAllowed,
        // IsDeleteAllowed,
        // handleAddNewICD,
    } = widgetUtilities;

    const API_URL_PATIENTENCOUNTER = enumUtil.controller.PatientEncounter

    let vitalKeysList = [
        "Height",
        "Weight",
        "BMI",
        "BMI Percentile",
        "BP",
        "Temperature",
        "Pulse",
        "Respiratory Rate",
        "O2 Saturation",
        "Pain",
        "Head Circumference"
    ];

    // US Customary Units
    let vitalUnitListUSList = [
        "in",   // Height
        "lb",   // Weight
        "",     // BMI
        "%",    // BMI Percentile
        "mmHg", // BP
        "°F",   // Temperature
        "bpm",  // Pulse
        "breaths/min", // Respiratory Rate
        "%",    // O2 Saturation
        "",     // Pain
        "in"    // Head Circumference
    ];

    // // Metric Units
    let vitalUnitListMetricList = [
        "cm",   // Height
        "kg",   // Weight
        "",     // BMI
        "%",    // BMI Percentile
        "mmHg", // BP
        "°C",   // Temperature
        "bpm",  // Pulse
        "breaths/min", // Respiratory Rate
        "%",    // O2 Saturation
        "",     // Pain
        "cm"    // Head Circumference
    ];

    // const [vitalsPastData, setVitalsPastData] = useState({});
    // const [pastVitalsLoaded, setPastVitalsLoaded] = useState(false);
    
    const vitalUnitList = useMemo(() => {
        if (searchParam?.VitalUnitType === "US Customary") {
            return vitalUnitListUSList;
        } else if (searchParam?.VitalUnitType === "Metric") {
            return vitalUnitListMetricList;
        }
    }, [searchParam?.VitalUnitType]);

    
    const handleGetUnits = (VitalUnitType) => {
        if (VitalUnitType === "US Customary") {
            return vitalUnitListUSList;
        } else if (VitalUnitType === "Metric") {
            return vitalUnitListMetricList;
        }
    }

    const handleChangeVitalData = (e) => {
        let { name, value } = e.target;
        setVitalData(prev =>
            prev.map(row => {
                if (row.VitalName === name) {
                    return {
                        ...row,
                        VitalValue: value,
                    }
                }
                return row;
            }))
    }

    const LoadVitalsData = () => {
        if (!searchParam?.EncounterDate) return;
        // setIsLoading(true);
        setPastVitalsLoaded(false);
        setVitalsPastData({})
        ServerRequestProtected(API_URL_PATIENTENCOUNTER + "/GetPastVital", 'post', {
            "TableName": enumUtil.enumAPITableName.Vital,
            "SearchCriteria": {
                "PatientID": patientID,
                "EncounterDate": searchParam.EncounterDate
            }
        })
            .then((response) => {
                // setIsLoading(false);
                setVitalsPastData(response);
                setPastVitalsLoaded(true);

                // const hasChiefComplaint = !!initialDataChiefComplaint?.trim?.();
                // let isVitalEmpty = initialDataVital?.length === 0 && response?.Vital?.length === 0;
                // let isObservationDataEmpty = ((initialDataCognitiveStatus?.length ?? 0) === 0 && (initialDataFunctionalStatus?.length ?? 0) === 0);

                // hasChiefComplaint &&
                //     setItemsCollapsed(prev => ({ ...prev, ['V']: isVitalEmpty, ['O']: isObservationDataEmpty }));
            }).catch((error) => {
                // setIsLoading(false)
                setPastVitalsLoaded(false);
            })
    }

    useEffect(() => {
        LoadVitalsData();
        LoadDD(searchParam?.EncounterDate);
    }, [searchParam?.EncounterDate]);

    let vitalValExist = vitalData.some(key => !isNull(key.VitalValue));
  return (
        <div className="d-flex gap-10">
        <div className="ar-form-counter flex-center">
            <p className='text text-black'>{props?.itemCount}</p>
        </div>
        <div className='objective-vitals w-100'
            // id={scrollNavIDs.refOBJECTIVEVitals}
            >
            <div className="d-flex justify-content-between align-items-center">
                <p className="heading fs-13 cursor-pointer" 
                // onClick={() => handleItemsExpanded('V')}
                    >Vitals</p>
                <div className="d-flex align-items-center gap-10">
                    <div className="d-flex align-items-center gap-2">
                        <label className="ar_radio-btn d-flex align-items-center gap-1">
                            <input
                                type="radio"
                                name={`VitalUnitType-${initialDataEncounterID}`}
                                value="US Customary"
                                checked={searchParam?.VitalUnitType === "US Customary"}
                                onChange={(e) =>
                                    setSearchParam((prev) => ({
                                        ...prev,
                                        VitalUnitType: e.target.value,
                                    }))
                                }
                            />
                            <span className="text ar-orange-text fs-13">US Customary</span>
                        </label>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <label className="ar_radio-btn d-flex align-items-center gap-1">
                            <input
                                type="radio"
                                name={`VitalUnitType-${initialDataEncounterID}`}
                                value="Metric"
                                checked={searchParam?.VitalUnitType === "Metric"}
                                onChange={(e) =>
                                    setSearchParam((prev) => ({
                                        ...prev,
                                        VitalUnitType: e.target.value,
                                    }))
                                }
                            />
                            <span className="text ar-orange-text fs-13">Metric</span>
                        </label>
                    </div>
                </div>

            </div>
            {/* {!itemsCollapsed?.['V'] &&
                ( */}
            <div className='hk-expand-table vitals-table BorderLess-table mt-2'>
                <table className='w-100'>
                    <thead>
                        <tr>
                            <th className='heading'>Date</th>
                            {/* // Fetched Vitals  // */}
                            {vitalsPastData?.Vital?.length > 0 &&
                                vitalsPastData.Vital.map(encounter =>
                                    (<th className='heading'>{encounter.Date}</th>)
                                )}
                            {/* // Current Encounter Vitals  // */}
                            {initialDataVital?.length > 0 &&
                                initialDataVital.map(encounter =>
                                    (<th className='heading'>{encounter.Date}</th>)
                                )}

                            {/* // New Encounter Vitals  // */}
                            {initialDataVital?.length === 0 &&
                                <th className='heading validate-color'>{searchParam.EncounterDate}</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {vitalKeysList.length > 0 &&
                            (vitalKeysList?.map((key, indexKey) => {
                                let vals = vitalData.length > 0 ?
                                    vitalData.find(row => row.VitalName === key) : {}
                                return (
                                    <tr>
                                        <td>{key}</td>

                                        {vitalsPastData?.Vital?.length > 0 ?
                                            vitalsPastData?.Vital?.map(encounter => {
                                                const currVitalUnitList = handleGetUnits(encounter.VitalUnitType);
                                                let value = (encounter.Vital.find(row => row.VitalName === key)?.VitalValue)
                                                return <td>{value} {value ? <span className='text fs-11 ar-light-color'>{currVitalUnitList?.[indexKey]}</span> : ''}</td>
                                            }) : <></>}

                                        {initialDataVital?.length > 0 ?
                                            initialDataVital.map(encounter => {
                                                let value = (encounter.Vital.find(row => row.VitalName === key)?.VitalValue)
                                                return <td>{value} {value ? <span className='text fs-11 ar-light-color'>{vitalUnitList?.[indexKey]}</span> : ''}</td>
                                            }) : <></>}
                                        {/* // Adding New Vital // */}
                                        {initialDataVital?.length === 0 &&
                                            (<td>
                                                <div className='d-flex align-items-center gap-1'>
                                                    <div className="input">
                                                        <input
                                                            type="text" className="form-control"
                                                            name={key}
                                                            id={key}
                                                            value={vals?.VitalValue}
                                                            onChange={handleChangeVitalData}
                                                        />
                                                    </div>
                                                    <p className="text fs-11 ar-light-color">{vitalUnitList?.[indexKey]}</p>
                                                </div>
                                            </td>)}
                                    </tr>)
                            }))}
                    </tbody>
                </table>
            </div>
             {/* )} */}
        </div>
        </div>
  )
}

export default Vitals